import React, {useEffect, useState} from "react";
import * as t from "counterpart";
import api from "../../../utilities/API";

function Locations(props)
{
    const [locations, setLocations] = useState([]);
    const [selected, setSelected] = useState({});

    // load initial data
    useEffect(() => {
        api("commerce/locations/?pickup=1", {
            result: ({data}) => {
                setLocations(data || []);
                if(data.length) {
                    onChange(data[0]);
                }
            },
            error: alert
        });
    }, []);

    //
    const onChange = loc => {
        setSelected(loc);
        if(props.onChange) {
            props.onChange(loc.id);
        }
    }

    return (
        <>
            <div className="col-md-6">
                <h3><span><i className="fa fa-location" /></span>{t("Pickup Location")}</h3>
                <div id="addresses">
                    {locations.map(loc =>
                        <div key={loc.id} className={"address "+(loc.id === selected.id ? "selected" : "")} onClick={() => onChange(loc)}>
                            {loc.name}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Locations;
